export const LogoMark = ({ size = 36, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    data-testid="logo-mark"
  >
    <defs>
      <linearGradient id="neyrein-g" x1="0" y1="0" x2="64" y2="64" gradientUnits="userSpaceOnUse">
        <stop stopColor="#38BDF8" />
        <stop offset="1" stopColor="#3B82F6" />
      </linearGradient>
    </defs>
    <rect width="64" height="64" rx="16" fill="url(#neyrein-g)" />
    <path
      d="M15 46 L15 18 L33 40 L33 18"
      stroke="#fff"
      strokeWidth="5.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M37 42 L50 27" stroke="#fff" strokeWidth="5" strokeLinecap="round" />
    <path d="M50 36 L50 27 L41 27" stroke="#fff" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
